'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  domain: '',
  menuToggle: {
    label: 'MENU'
  },
  logo: {
    href: '/'
  },
  mainBtn: [{
    text: 'CONTATO',
    link: '/contact'
  }, {
    text: 'FAÇA LOGIN',
    link: ''
  }],
  loginLink: {
    text: 'FAÇA LOGIN',
    link: ''
  },
  siteLinks: [{
    title: {
      text: 'PRODUTOS'
    },
    list: [{
      text: 'Expense',
      src: '/expense-management'
    }, {
      text: 'Travel',
      src: '/travel-booking'
    }, {
      text: 'Business Intelligence',
      src: '/business-intelligence'
    }, {
      text: 'Travel Request',
      src: '/products/travel-request'
    }, {
      text: 'DEMO DE EXPENSE',
      src: '/self-guided-demo-expense-pt-br',
      classes: 'call-out'
    }]
  }, {
    title: {
      text: 'FUNCIONALIDADES'
    },
    list: [{
      text: 'Integração de dados SAP',
      src: '/sap-integration'
    }, {
      text: 'Suporte ao Usuário / Integração de Dados',
      src: '/service-administration'
    }]
  }, {
    title: {
      text: 'SOBRE A CONCUR'
    },
    list: [{
      text: 'Por que Concur?',
      src: '/why-concur'
    }, {
      text: 'Escritórios',
      src: '/contact/offices'
    }, {
      text: 'SAP Concur na Midia',
      src: '/media-resources/press-releases'
    }, {
      text: 'Central de Recursos',
      src: '/resource-center'
    }, {
      text: 'CONTATO',
      src: '/contact',
      classes: 'call-out'
    }]
  }],
  supportLinks: [{
    text: 'CONTATO',
    href: '/contact'
  }, {
    text: 'PRIVACY POLICY',
    href: '/privacy-policy'
  }],
  mobileAppText: {
    text: 'GET CONCUR MOBILE APP'
  }
};